module.exports = __webpack_public_path__ + "img/3.c62e6746.png";